import { useTranslation } from 'react-i18next'
import { CountWithDetailsButton } from './CountWithDetailsButton'

export function HomologationCountriesCount({
  homologatedCountriesCount,
  countriesCount,
  onOpenModal,
}: Readonly<{
  homologatedCountriesCount: number
  countriesCount: number
  onOpenModal: () => void
}>) {
  const { t } = useTranslation()

  return (
    <CountWithDetailsButton
      ariaLabel={t('aria-label.open-homologation-modal')}
      dataTestid="manufacture-country_eye-icon"
      onOpenDetails={onOpenModal}
    >
      {t('products-page.product-card.countries-count', {
        homologatedCountries: homologatedCountriesCount,
        totalCountries: countriesCount,
      })}
    </CountWithDetailsButton>
  )
}
